import Checkbox from "../../ui/Checkbox";
import Item from "../../ui/List/Item";
import Props from "./props";
import React from "react";
import useProfessionActiveCategoryToggle from "../../../../state/hooks/ProfessionHooks/useProfessionActiveCategoryToggle";

const ProfessionCategory: React.FC<Props> = ({ name, term_id, order, isSubLevel, children }) => {
    const { isActiveCategory, toggleProfessionCategory } = useProfessionActiveCategoryToggle(term_id);
    return (
        <Item
            isSubLevel={isSubLevel}
            active={isActiveCategory}
            onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                e.stopPropagation();
                toggleProfessionCategory(term_id);
            }}
        >
            <Checkbox isSubLevel={isSubLevel} active={isActiveCategory} />
            <span>
                {order && order.length ? `${order.join(".")} - ` : null}
                {name}
            </span>
            {children}
        </Item>
    );
};

export default ProfessionCategory;
